import { gallery } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function PhotoGallery() {
  return (
    <section id="gallery" className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
            <SectionHeading
              label="On The Scene"
              title="现场实拍：把画面留档"
              desc="黑料网吃瓜现场以图集形式保存，方便对照当时的氛围、物料与细节，而不是只记得几句传言。"
            />
            <span className="text-sm text-foreground-500 whitespace-nowrap">共 18 张 · 已归档 6 组</span>
          </div>

          <div className="mt-8 md:mt-10 grid grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
            {gallery.map((item) => (
              <a key={item.caption} href="#covers" className="group relative block overflow-hidden rounded-lg cursor-pointer">
                <div className="w-full aspect-square overflow-hidden">
                  <img
                    src={item.image}
                    alt={`${item.caption} - 黑料网吃瓜现场实拍`}
                    title={`${item.caption} 黑料网吃瓜现场`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/15 to-transparent"></div>
                <div className="absolute inset-x-0 bottom-0 p-3 md:p-4">
                  <span className="inline-block text-xs px-2 py-0.5 rounded-full bg-background-50/90 text-foreground-900">
                    {item.tag}
                  </span>
                  <p className="mt-2 text-xs md:text-sm text-background-50 leading-snug">{item.caption}</p>
                </div>
                <span className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center rounded-md bg-background-50/90 text-foreground-900 opacity-0 group-hover:opacity-100 transition-opacity">
                  <i className="ri-zoom-in-line text-base"></i>
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}